import { lookup } from 'mime-types'
import { CONFIG } from '../config'

const FileHelper = {
  getContentType: (filePath?: string): string => {
    if (!filePath) return ''
    const result = lookup(filePath)
    return !result ? '' : (result as string)
  },
  generateFileNameAndContentType: ({ filePath }: any) => {
    const contentType = FileHelper.getContentType(filePath)
    const contentTypeSplit = contentType.split('/')
    const fileExt: string = contentTypeSplit[contentTypeSplit.length - 1]
    const fileName: string =
      fileExt /*FileHelper.generateFileName({ fileExt })*/

    return {
      fileName,
      contentType,
    }
  },

  getThumbnailImage: (imageKeys?: any) => {
    if (!imageKeys || imageKeys.length === 0) {
      return null
    }
    const imageKey = imageKeys[0]
    return FileHelper.getFileUrl(imageKey)
  },

  getFileUrl: (fileKey?: any) => {
    if (!fileKey) {
      return null
    }
    return `${CONFIG.LAPUTAN_IMAGE_SERVER_URL}/${fileKey}`
  },
}

export { FileHelper }
